const RICOS_VERSION = "10.126.2";
export {
  RICOS_VERSION
};
//# sourceMappingURL=version.js.map
